module.exports = __webpack_public_path__ + "img/concertHall.4a6d50ed.png";